export const inlineAlignMap = {
  start: 'flex-start',
  end: 'flex-end',
  left: 'flex-start',
  right: 'flex-end',
  top: 'flex-start',
  bottom: 'flex-end',
  center: 'center',
  'space-between': 'space-between',
  'space-around': 'space-around',
  'space-evenly': 'space-evenly'
} as const;

export const blockAlignMap = {
  start: 'flex-start',
  end: 'flex-end',
  top: 'flex-start',
  bottom: 'flex-end',
  left: 'flex-start',
  right: 'flex-end',
  center: 'center',
  baseline: 'baseline',
  stretch: 'stretch'
} as const;

export type BlockAlign = keyof typeof blockAlignMap;
export type InlineAlign = keyof typeof inlineAlignMap;
